<template>
  <div>
    <div class="d-block">
      <b-tabs v-model="tabIndex">
        <div
          class="d-flex justify-content-between py-3 align-items-center"
          v-if="!isEdit && tabIndex == 0"
        >
          <div class="title-18px f-16px">รูปแบบการลงทะเบียน</div>
          <InputSelect
            :options="[
              { name: 'บุคคลธรรมดา', id: 0 },
              { name: 'นิติบุคคล', id: 1 },
            ]"
            valueField="id"
            textField="name"
            class="input-type"
            v-model="form.is_company"
            @onDataChange="
              (val) => {
                form.is_company = val;
                this.$v.$reset();
                $emit('reset');
                ext.tel = ''
              }
            "
          >
            <template v-slot:option-first>
              <b-form-select-option :value="null" disabled
                >-- ประเภทลูกค้า --</b-form-select-option
              >
            </template>
          </InputSelect>
        </div>
        <b-tab title="1. ข้อมูลส่วนตัว" active>
          <div class="p-3" :class="{ 'register-box': !isMobile }">
            <b-row v-if="form.is_company == 0">
              <template
                v-for="profile in fields.filter((el) => el.group_id == 1)"
              >
                <b-col
                  md="6"
                  v-if="profile.field_profile_type_id !== 22"
                  :key="'field-' + profile.name"
                >
                  <div
                    :set="
                      (field =
                        $v.form[checkIsProfile(profile.field_profile_type_id)])
                    "
                    :id="'field-' + profile.profile_name"
                  >
                    <b-row v-if="profile.field_type_id == 1">
                      <b-col>
                        <InputText
                          :disabled="
                            form.is_id_card == 1 &&
                            profile.field_profile_type_id !== 10
                          "
                          :textFloat="changeName(profile)"
                          :placeholder="changeName(profile)"
                          class="margin-input f-regular"
                          :type="checkFieldConditon(profile)"
                          :name="profile.profile_name"
                          :isRequired="
                            checkRequired(
                              checkIsProfile(profile.field_profile_type_id)
                            )
                          "
                          :class="{
                            'mb-2': profile.field_profile_type_id !== 10,
                          }"
                          :isValidate="field.$error"
                          :v="field"
                          v-model="
                            form[checkIsProfile(profile.field_profile_type_id)]
                          "
                        />
                      </b-col>
                      <b-col
                        v-if="profile.field_profile_type_id == 10"
                        cols="3"
                        class="pl-0"
                      >
                        <InputText
                          textFloat="ต่อ"
                          placeholder="ต่อ"
                          class="margin-inputf-regular"
                          :type="checkFieldConditon(profile)"
                          :name="profile.profile_name"
                          :class="{
                            'mb-2': profile.field_profile_type_id !== 10,
                          }"
                          v-model="ext.tel"
                      /></b-col>
                      <b-col
                        cols="12"
                        v-if="profile.field_profile_type_id == 10"
                      >
                        <p
                          class="text-right text-link my-2"
                          @click="addTel()"
                          v-if="profile.field_profile_type_id == 10"
                        >
                          เบอร์โทรศัพท์สำรอง
                        </p></b-col
                      >
                    </b-row>

                    <b-row
                      v-else-if="
                        profile.field_profile_type_id == 2 ||
                        profile.field_profile_type_id == 21
                      "
                    >
                      <b-col>
                        <InputSelect
                          :disabled="form.is_id_card == 1"
                          :title="profile.name"
                          :placeholder="profile.name"
                          v-model="
                            form[checkIsProfile(profile.field_profile_type_id)]
                          "
                          :options="
                            profile.field_choices.map((x) => ({
                              text: x.display_name,
                              value: x.name,
                            }))
                          "
                          className="mb-2"
                          @onDataChange="
                            (val) =>
                              handleSelected(
                                val,
                                checkIsProfile(profile.field_profile_type_id),
                                profile.field_choices
                              )
                          "
                          :validateText="profile.validate_text"
                          :isValidate="field.$error"
                          :v="field"
                        >
                          <template v-slot:option-first>
                            <b-form-select-option :value="null" disabled
                              >-- {{ profile.name }} --</b-form-select-option
                            >
                          </template></InputSelect
                        ></b-col
                      >

                      <b-col
                        v-if="
                          isOtherPrefix && profile.field_profile_type_id == 2
                        "
                      >
                        <InputText
                          className="mb-2"
                          textFloat=" "
                          v-model="otherPrefix"
                          :placeholder="
                            profile.field_choices.find(
                              (x) => x.choice_type_id == 3
                            ).description
                          "
                          :disabled="form.is_id_card == 1"
                        >
                        </InputText
                      ></b-col>

                      <b-col
                        v-else-if="
                          isOtherGender && profile.field_profile_type_id == 21
                        "
                      >
                        <InputText
                          className="mb-2"
                          textFloat=" "
                          v-model="otherGender"
                          :placeholder="
                            profile.field_choices.find(
                              (x) => x.choice_type_id == 3
                            ).description
                          "
                          :disabled="form.is_id_card == 1"
                        >
                          >
                        </InputText></b-col
                      >
                    </b-row>
                    <div
                      v-else-if="profile.field_type_id == 7"
                      class="datetime-container"
                    >
                      <datetime
                        :disabled="form.is_id_card == 1"
                        type="date"
                        textFloat="วันเกิด "
                        name="birthday"
                        :ref="'data-picker' + profile.name"
                        placeholder="วันเกิด"
                        :format="'dd/MM/yyyy'"
                        :class="[
                          'date-picker-input',
                          'date-filter',
                          {
                            'border-red': field.$error,
                          },
                        ]"
                        value-zone="Asia/Bangkok"
                        v-model="
                          form[checkIsProfile(profile.field_profile_type_id)]
                        "
                        @input="
                          (val) =>
                            (form[
                              checkIsProfile(profile.field_profile_type_id)
                            ] = val)
                        "
                        :maxDatetime="now"
                        class="datetime-h mb-2"
                        :validateText="field.validate_text"
                        :isValidate="field.$error"
                      >
                        <label for="startDate" slot="before">
                          {{ profile.name }}
                          <span
                            class="text-danger"
                            v-if="
                              checkRequired(
                                checkIsProfile(profile.field_profile_type_id)
                              )
                            "
                            >*
                          </span>
                        </label>
                        <font-awesome-icon icon="calendar-alt" />
                        <span
                          class="description text-danger text-error"
                          slot="after"
                          v-if="field.$error"
                          >กรุณากรอกข้อมูล
                        </span>
                      </datetime>
                      <div
                        class="calendar-icon"
                        :class="{
                          'calendar-icon-top': field.$error,
                        }"
                        @click="
                          $refs['date-picker' + profile.name].isOpen = true
                        "
                      >
                        <font-awesome-icon icon="calendar-alt" />
                      </div>
                    </div>
                    <div
                      v-else-if="profile.field_type_id == 5"
                      class="datetime-container"
                    >
                      <datetime
                        :disabled="form.is_id_card == 1"
                        type="date"
                        :textFloat="changeName(profile)"
                        :name="profile.profile_name"
                        :ref="'data-picker' + profile.name"
                        :placeholder="changeName(profile)"
                        :format="'dd/MM/yyyy'"
                        :class="[
                          'date-picker-input',
                          'date-filter',
                          {
                            'border-red': field.$error,
                          },
                        ]"
                        v-model="
                          form[checkIsProfile(profile.field_profile_type_id)]
                        "
                        class="datetime-h mb-2"
                        :validateText="field.validate_text"
                        :isValidate="field.$error"
                      >
                        <label for="startDate" slot="before"
                          >{{ profile.name }}
                          <span
                            class="text-danger"
                            v-if="
                              checkRequired(
                                checkIsProfile(profile.field_profile_type_id)
                              )
                            "
                            >*
                          </span>
                        </label>
                        <font-awesome-icon icon="calendar-alt" />
                        <span
                          class="description text-danger text-error"
                          slot="after"
                          v-if="field.$error"
                          >กรุณากรอกข้อมูล
                        </span>
                      </datetime>
                      <div
                        class="calendar-icon"
                        :class="{
                          'calendar-icon-top': field.$error,
                        }"
                        @click="
                          $refs['date-picker' + profile.name].isOpen = true
                        "
                      >
                        <font-awesome-icon icon="calendar-alt" />
                      </div>
                    </div>

                    <div v-else-if="profile.field_type_id == 8">
                      <label v-if="changeName(profile)">
                        {{ changeName(profile) }}
                      </label>

                      <InputUploadImage
                        :disabled="form.is_id_card == 1"
                        :id="profile.id"
                        :img="
                          form[checkIsProfile(profile.field_profile_type_id)]
                        "
                        v-model="
                          form[checkIsProfile(profile.field_profile_type_id)]
                        "
                        :v="field"
                        @setFileName="
                          (val) =>
                            setImageName(val, profile.field_profile_type_id)
                        "
                        :validateText="field.validate_text"
                        :isValidate="field.$error"
                      />
                      <div class="f-12 color-gray mt-1 mb-2">
                        ไฟล์ที่อัพโหลดต้องเป็นไฟล์นามสกุล PDF, PNG ,JPG
                        ขนาดไม่เกิน 2.5 mb เท่านั้น
                      </div>
                    </div>
                  </div>
                </b-col>
              </template>
            </b-row>
            <template v-else-if="form.is_company">
              <CompanyFields
                @AddOptionalTelephone="addTel()"
                :ext="ext"
                class="mb-3"
                :companyFields="companyFields"
                :companyForm="companyForm"
                :documentFields="documentFields"
                :$v="$v"
                @changeInformation="handleChangeTypeRegister"
              ></CompanyFields>
            </template>

            <b-form-checkbox
              v-model="form.is_consent"
              :value="1"
              :unchecked-value="0"
              :id="'consent-main'"
            >
              <label class="privacy-txt" :for="'consent-main'">
                ฉันยอมรับ
                <div
                  class="text-underline pointer d-inline"
                  @click="showPolicy"
                >
                  นโยบายความเป็นส่วนตัว
                </div>
                และ
                <div class="text-underline pointer d-inline" @click="showTerm">
                  ข้อกำหนดเงื่อนไข
                </div>
                / I accept the
                <div
                  class="text-underline pointer d-inline"
                  @click="showPolicy"
                >
                  Privacy Policy
                </div>

                and acknowledge the
                <div class="text-underline pointer d-inline" @click="showTerm">
                  Terms and Conditions
                </div>
              </label>
            </b-form-checkbox>
            <template v-for="items of consentList">
              <b-form-checkbox
                v-model="items.is_consent"
                :value="1"
                class="text-nowrap"
                :unchecked-value="0"
                :key="'consent-' + items.id"
                :id="'consent-' + items.id"
              >
                <label class="privacy-txt" :for="'consent-' + items.id">
                  <template v-for="(part, index) in items.parsedDescription">
                    <span
                      :key="index"
                      v-if="part === '{{term}}'"
                      class="text-underline pointer d-inline"
                      @click.prevent="showTerm"
                    >
                      ข้อกำหนดเงื่อนไข
                    </span>
                    <span
                      :key="index"
                      v-else-if="part === '{{policy}}'"
                      class="text-underline pointer d-inline"
                      @click.prevent="showPolicy"
                    >
                      นโยบายความเป็นส่วนตัว
                    </span>
                    <template v-else>{{ part }}</template>
                  </template>
                </label>

                <span v-if="items.is_required == 1" class="text-error"
                  >&nbsp;*</span
                >
              </b-form-checkbox>
              <div
                :key="'consent-error-message' + items.id"
                v-if="
                  items.is_required == 1 &&
                  items.is_consent == 0 &&
                  consentError
                "
                class="text-error ml-4"
              >
                Please Accept Consent
              </div>
            </template>
          </div>
        </b-tab>
        <b-tab title="2. ข้อมูลที่อยู่">
          <div
            v-if="!form.is_company"
            class="p-3"
            :class="{ 'register-box': !isMobile }"
          >
            <b-row>
              <b-col
                md="6"
                v-for="profile in fields.filter((el) => el.group_id == 2)"
                :key="'address-' + profile.field_profile_type_id"
              >
                <InputSelect
                  :disabled="form.is_id_card == 1"
                  v-if="profile.field_profile_type_id == 24"
                  :title="profile.name"
                  :placeholder="profile.name"
                  :name="profile.name"
                  v-model="form[checkIsProfile(profile.field_profile_type_id)]"
                  :options="country"
                  className="mb-2"
                  valueField="englishName"
                  textField="englishName"
                  @onDataChange="(val) => handleChangeCountry(val)"
                >
                  <template v-slot:option-first>
                    <b-form-select-option :value="null" disabled>
                      -- ประเทศ --
                    </b-form-select-option>
                  </template>
                </InputSelect>
                <div v-if="form.country === 'ประเทศไทย'">
                  <InputText
                    :disabled="form.is_id_card == 1"
                    v-if="
                      profile.field_type_id == 1 &&
                      profile.field_profile_type_id !== 19 &&
                      profile.field_profile_type_id !== 18 &&
                      profile.field_profile_type_id !== 17 &&
                      profile.field_profile_type_id !== 16
                    "
                    :placeholder="profile.name"
                    :textFloat="profile.name"
                    v-model="
                      form[checkIsProfile(profile.field_profile_type_id)]
                    "
                    className="mb-2"
                  />
                  <InputSelect
                    v-else-if="
                      checkIsProfile(profile.field_profile_type_id) ===
                      'province'
                    "
                    title="จังหวัด"
                    placeholder="จังหวัด"
                    name="province"
                    v-model="form.province"
                    className="mb-2"
                    :options="
                      province.map((x) => ({ text: x.name, value: x.name }))
                    "
                    @onDataChange="(val) => handleChange(val, 'province')"
                  >
                    <template v-slot:option-first>
                      <b-form-select-option :value="null" disabled
                        >-- จังหวัด --</b-form-select-option
                      >
                    </template>
                  </InputSelect>
                  <InputSelect
                    v-else-if="
                      checkIsProfile(profile.field_profile_type_id) ===
                      'district'
                    "
                    title="เขต"
                    placeholder="เขต"
                    name="district"
                    v-model="form.district"
                    className="mb-2"
                    :options="
                      district.map((x) => ({ text: x.name, value: x.name }))
                    "
                    :disabled="!form.province"
                    @onDataChange="(val) => handleChange(val, 'district')"
                    ><template v-slot:option-first>
                      <b-form-select-option :value="null" disabled
                        >-- เขต --</b-form-select-option
                      >
                    </template>
                  </InputSelect>
                  <InputSelect
                    v-else-if="
                      checkIsProfile(profile.field_profile_type_id) ===
                      'subdistrict'
                    "
                    title="แขวง"
                    placeholder="แขวง"
                    name="subdistrict"
                    v-model="form.subdistrict"
                    className="mb-2"
                    :options="
                      subdistrict.map((x) => ({ text: x.name, value: x.name }))
                    "
                    :disabled="!form.district"
                    @onDataChange="(val) => handleChange(val, 'subdistrict')"
                  >
                    <template v-slot:option-first>
                      <b-form-select-option :value="null" disabled
                        >-- แขวง --</b-form-select-option
                      >
                    </template>
                  </InputSelect>
                  <InputText
                    v-else-if="
                      checkIsProfile(profile.field_profile_type_id) ===
                      'zip_code'
                    "
                    ref="postNum"
                    @onEnter="handleEnter(1)"
                    textFloat="รหัสไปรษณีย์"
                    placeholder="รหัสไปรษณีย์"
                    name="zip_code"
                    v-model="form.zip_code"
                    className="mb-2"
                    :disabled="true"
                  />
                </div>
                <!-- <b-col v-if="form.country != 'ประเทศไทย'" cols="12"> -->
                <template v-else>
                  <InputText
                    :disabled="form.is_id_card == 1"
                    v-if="profile.field_profile_type_id != 24"
                    :placeholder="profile.name"
                    :textFloat="profile.name"
                    v-model="
                      companyForm[checkIsProfile(profile.field_profile_type_id)]
                    "
                    type="text
                    "
                    className="mb-2"
                  />
                </template>
              </b-col>
            </b-row>
          </div>

          <div v-else class="p-3" :class="{ 'register-box': !isMobile }">
            <b-row>
              <b-col
                md="6"
                v-for="profile in companyFields.filter(
                  (el) => el.group_id == 2
                )"
                :key="'address-' + profile.field_profile_type_id"
              >
                <InputSelect
                  :disabled="form.is_id_card == 1"
                  v-if="profile.field_profile_type_id == 30"
                  :title="profile.name"
                  :placeholder="profile.name"
                  :name="profile.name"
                  v-model="
                    companyForm[checkIsProfile(profile.field_profile_type_id)]
                  "
                  :options="country"
                  className="mb-2"
                  valueField="englishName"
                  textField="englishName"
                  @onDataChange="(val) => handleChangeCountry(val)"
                >
                  <template v-slot:option-first>
                    <b-form-select-option :value="null" disabled>
                      -- ประเทศ --
                    </b-form-select-option>
                  </template>
                </InputSelect>
                <div v-if="form.country === 'ประเทศไทย'">
                  <InputText
                    :disabled="form.is_id_card == 1"
                    v-if="
                      profile.field_type_id == 1 &&
                      profile.field_profile_type_id !== 19 &&
                      profile.field_profile_type_id !== 18 &&
                      profile.field_profile_type_id !== 17 &&
                      profile.field_profile_type_id !== 16
                    "
                    :placeholder="profile.name"
                    :textFloat="profile.name"
                    v-model="
                      companyForm[checkIsProfile(profile.field_profile_type_id)]
                    "
                    className="mb-2"
                  />
                  <InputSelect
                    v-else-if="
                      checkIsProfile(profile.field_profile_type_id) ===
                      'province'
                    "
                    title="จังหวัด"
                    placeholder="จังหวัด"
                    name="province"
                    v-model="companyForm.province"
                    className="mb-2"
                    :options="
                      province.map((x) => ({ text: x.name, value: x.name }))
                    "
                    @onDataChange="
                      (val) => handleChangeCompany(val, 'province')
                    "
                  >
                    <template v-slot:option-first>
                      <b-form-select-option :value="null" disabled
                        >-- จังหวัด --</b-form-select-option
                      >
                    </template>
                  </InputSelect>
                  <InputSelect
                    v-else-if="
                      checkIsProfile(profile.field_profile_type_id) ===
                      'district'
                    "
                    title="เขต"
                    placeholder="เขต"
                    name="district"
                    v-model="companyForm.district"
                    className="mb-2"
                    :options="
                      district.map((x) => ({ text: x.name, value: x.name }))
                    "
                    :disabled="!companyForm.province"
                    @onDataChange="
                      (val) => handleChangeCompany(val, 'district')
                    "
                    ><template v-slot:option-first>
                      <b-form-select-option :value="null" disabled
                        >-- เขต --</b-form-select-option
                      >
                    </template>
                  </InputSelect>
                  <InputSelect
                    v-else-if="
                      checkIsProfile(profile.field_profile_type_id) ===
                      'subdistrict'
                    "
                    title="แขวง"
                    placeholder="แขวง"
                    name="subdistrict"
                    v-model="companyForm.subdistrict"
                    className="mb-2"
                    :options="
                      subdistrict.map((x) => ({ text: x.name, value: x.name }))
                    "
                    :disabled="!companyForm.district"
                    @onDataChange="
                      (val) => handleChangeCompany(val, 'subdistrict')
                    "
                  >
                    <template v-slot:option-first>
                      <b-form-select-option :value="null" disabled
                        >-- แขวง --</b-form-select-option
                      >
                    </template>
                  </InputSelect>
                  <InputText
                    v-else-if="
                      checkIsProfile(profile.field_profile_type_id) ===
                      'zip_code'
                    "
                    ref="postNum"
                    @onEnter="handleEnter(1)"
                    textFloat="รหัสไปรษณีย์"
                    placeholder="รหัสไปรษณีย์"
                    name="zip_code"
                    v-model="companyForm.zip_code"
                    className="mb-2"
                    :disabled="true"
                  />
                </div>
                <!-- <b-col v-if="form.country != 'ประเทศไทย'" cols="12"> -->
                <template v-else>
                  <InputText
                    :disabled="form.is_id_card == 1"
                    v-if="profile.field_profile_type_id != 30"
                    :placeholder="profile.name"
                    :textFloat="profile.name"
                    v-model="
                      companyForm[checkIsProfile(profile.field_profile_type_id)]
                    "
                    type="text
                    "
                    className="mb-2"
                  />
                </template>
              </b-col>
            </b-row>
          </div>
        </b-tab>

        <b-tab v-if="dynamicField.length > 0" title="3. ข้อมูลเพิ่มเติม">
          <DynamicFields
            :isMobile="isMobile"
            :form="form"
            :dynamicField="dynamicField"
            keyRequired="isRequired"
          ></DynamicFields>
        </b-tab>
        <b-tab
          v-if="form.is_company"
          :title="
            dynamicField.length > 4
              ? '3. เอกสารเพิ่มเติม'
              : '4. เอกสารเพิ่มเติม'
          "
        >
          <div class="p-3" :class="{ 'register-box': !isMobile }">
            <DocumentFields
              :$v="$v"
              :documentFields="documentFields"
              :documents="companyForm.documents"
              ref="documentFields"
            ></DocumentFields>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputRadioGroup from "@/components/inputs/InputRadioGroup";
import InputDatePickerFilter from "@/components/inputs/InputDatePickerFilter";
import InputSelect from "@/components/inputs/InputSelect";
import { fieldInForm2, profile_fields2 } from "@/assets/json/fieldProfile.js";
import { province } from "@/assets/json/fieldAddress.js";
import InputTextArea from "@/components/inputs/InputTextArea";

import {
  required,
  email,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import InputUploadImage from "../inputs/InputUploadImage.vue";
import DynamicFields from "./DynamicFields.vue";
import CompanyFields from "./component/CompanyFields.vue";
import DocumentFields from "./DocumentFields.vue";
import { requiredIf } from "vuelidate/lib/validators";
const country = require("@/lang/country.json");

// const Script_checkID = (id) => {
//   console.log(id);
//   let i = 0,
//     sum = 0;

//   if (id.substring(0, 1) == 0) return false;
//   for (i = 0, sum = 0; i < 12; i++) sum += parseFloat(id.charAt(i)) * (13 - i);
//   if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;
//   return true;
// };

export default {
  components: {
    // province,
    CompanyFields,
    InputSelect,
    InputText,
    InputDatePickerFilter,
    InputRadioGroup,
    InputUploadImage,
    InputTextArea,
    DynamicFields,
    DocumentFields,
  },
  props: {
    form: {
      type: Object,
      default: true,
    },
    companyForm: {
      type: Object,
    },
    isEdit: {
      type: Boolean,
    },
    isMobile: {
      type: Boolean,
    },
    fields: {
      type: Array,
    },
    dynamicField: {
      type: Array,
    },
    companyFields: {
      type: Array,
    },
  },
  data() {
    return {
      isLoading: false,
      now: null,
      province,
      country: "ประเทศไทย",
      district: [],
      subdistrict: [],
      birthday: "",
      tabIndex: 0,
      isOtherPrefix: false,
      otherPrefix: "",
      isOtherGender: false,
      otherGender: "",
      country,
      ext: { tel: "" },
      consentList: [],
      consentError: false,
      documentFields: [],
    };
  },

  validations() {
    let company_profile = JSON.parse(JSON.stringify(profile_fields2));

    for (const item of this.fields) {
      const key = this.checkIsProfile(item.field_profile_type_id);
      if (key) {
        if (
          key === "first_name_th" ||
          key === "last_name_th" ||
          key === "telephone"
        ) {
          if (item.field_profile_type_id == 11) {
            profile_fields2[key] = { required, email };
          } else if (item.field_profile_type_id == 10)
            profile_fields2[key] = {
              required,
              maxLength: maxLength(10),
              minLength: minLength(10),
              numeric,
            };
          else if (item.field_profile_type_id == 9) {
            profile_fields2["birthday"] = {
              required,
            };
          } else profile_fields2[key] = { required };
        } else {
          if (item.field_profile_type_id == 11) {
            profile_fields2[key] = { email };
          } else if (item.field_profile_type_id == 1)
            profile_fields2[key] = {
              maxLength: maxLength(13),
              minLength: minLength(13),
              numeric,
            };
          else profile_fields2[key] = {};
        }
      }
    }

    for (const item of this.companyFields.filter((x) => x.group_id == 1)) {
      const key = this.checkIsProfile(item.field_profile_type_id);

      if (key) {
        if (item.required) {
          if (item.field_profile_type_id == 11) {
            company_profile[key] = { email, required };
          } else if (item.field_profile_type_id == 10)
            company_profile[key] = {
              maxLength: maxLength(10),
              minLength: minLength(10),
              numeric,
              required,
            };
          else if (item.field_profile_type_id == 1)
            company_profile[key] = {
              maxLength: maxLength(13),
              minLength: minLength(13),
              numeric,
              required,
            };
          else company_profile[key] = { required };
        } else {
          if (item.field_profile_type_id == 11) {
            company_profile[key] = { email };
          } else if (item.field_profile_type_id == 10) {
            company_profile[key] = {
              maxLength: maxLength(10),
              minLength: minLength(10),
              numeric,
            };
          } else if (item.field_profile_type_id == 1) {
            company_profile[key] = {
              maxLength: maxLength(13),
              minLength: minLength(13),
              numeric,
            };
          } else company_profile[key] = {};
        }
      }
    }

    return {
      form: profile_fields2,
      companyForm: {
        ...company_profile,
        documents: {
          $each: {
            path: {
              required: requiredIf(function (val) {
                return (
                  this.form.is_company &&
                  ((this.companyForm.company_information == "จดทะเบียน" &&
                    val.is_register &&
                    val.is_required) ||
                    (this.companyForm.company_information == "ไม่จดทะเบียน" &&
                      val.is_not_register &&
                      val.is_required))
                );
              }),
            },
          },
        },
        company_branch: {
          required: requiredIf(function (val) {
            return this.form.is_company && val.company_branch_type == "สาขา";
          }),
        },
        company_branch_no: {
          required: requiredIf(function (val) {
            return this.form.is_company && val.company_branch_type == "สาขา";
          }),
        },
      },
    };
  },
  async created() {
    if (this.form.province)
      await this.loadAddress(this.form.province, "province");
    if (this.form.district)
      await this.loadAddress(this.form.district, "district");
    if (this.form.subdistrict)
      await this.loadAddress(this.form.subdistrict, "subdistrict");
    this.getConsentList();
    if (this.form.is_company || !this.isEdit) {
      await this.getDoccumentFields();
    }
    // console.log(this.form);
    this.now = this.$moment().format("YYYY-MM-DDTHH:mm:ss");
    // this.form.country =
    //   this.form.country == ("" || null) ? "ประเทศไทย" : this.form.country;
    // if (this.isEdit) {
    //   this.form.birthday = new Date(this.form.birthday).toISOString();
    //   let prefixFind = this.fields.find((x) => x.field_profile_type_id == 2);
    //   let prefixField = prefixFind ? prefixFind.field_choices : null;
    //   let prefixOther = prefixField
    //     ? prefixField.find((x) => x.choice_type_id == 3)
    //     : [];
    //   let genderFind = this.fields.find((x) => x.field_profile_type_id == 21);
    //   let genderField = genderFind ? genderFind.field_choices : null;
    //   let genderOther = genderFind
    //     ? genderField.find((x) => x.choice_type_id == 3)
    //     : [];
    //   let optionsPrefix = prefixOther ? prefixOther.name : [];
    //   let optionsGender = genderOther ? genderOther.name : [];
    //   if (prefixField) {
    //     if (this.form.prefix)
    //       if (
    //         (!prefixField.map((x) => x.name).includes(this.form.prefix) &&
    //           this.form.prefix !== null) ||
    //         this.form.prefix.includes("อื่นๆ")
    //       ) {
    //         this.otherPrefix = this.form.prefix;
    //         this.form.prefix = optionsPrefix;
    //         this.isOtherPrefix = true;
    //       }
    //   }
    //   if (genderField) {
    //     if (this.form.gender == "N/A") {
    //       this.form.gender = null;
    //     }
    //     if (this.form.gender)
    //       if (
    //         (!genderField.map((x) => x.name).includes(this.form.gender) &&
    //           this.form.gender !== null) ||
    //         this.form.gender.includes("อื่นๆ")
    //       ) {
    //         this.otherGender = this.form.gender;
    //         this.form.gender = optionsGender;
    //         this.isOtherGender = true;
    //       }
    //   }

    if (this.form.telephone && this.form.telephone.includes("-")) {
      let phone = this.form.telephone.split("-");
      this.form.telephone = phone[0];
      this.ext.tel = phone[1];
    } else if (
      this.companyForm.companyForm && 
      this.companyForm.telephone.includes("-")
    ) {
      let phone = this.companyForm.telephone.split("-");
      this.companyForm.telephone = phone[0];
      this.ext.tel = phone[1];
    }

    // }
    // this.getAddress();
  },

  computed: {
    ...mapGetters({
      mainLoading: "getMainLoading",
      dateTimeFix: "getDateTimeFix",
      branchId: "getBranchId",
    }),
    isConsentError() {
      let check = this.consentList
        .filter((el) => el.is_required)
        .every((el) => el.is_consent == 1);
      if (check) this.consentError = false;
      return check;
    },
  },
  methods: {
    async getConsentList() {
      if (this.isEdit) return;
      try {
        const res = await this.axios(
          `${this.$baseUrl}/customer/additional_consent/listactive`
        );
        this.consentList = res.detail.map((item) => {
          const parts = item.description
            .split(/(\{\{.*?\}\})/g)
            .filter(Boolean);
          let isConsent = false;

          if (this.form.user_additional_consent_response_list)
            isConsent = this.form.user_additional_consent_response_list.find(
              (el) => el.additional_consent_id == item.id
            );

          return {
            ...item,
            is_consent: isConsent ? isConsent : 0,
            parsedDescription: parts,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getDoccumentFields() {
      const res = await this.axios(
        `${this.$baseUrl}/customer/GetDocumentSetting`
      );
      this.documentFields = res.detail || [];

      const filteredFields = this.documentFields.filter((x) =>
        this.companyForm.company_information === "จดทะเบียน"
          ? x.is_register
          : x.is_not_register
      );
      if (this.isEdit) {
        this.companyForm.documents = filteredFields
          .map((el, index) => {
            const existing = this.companyForm.documents.find(
              (x) => x.document_type_id == el.id
            );

            return {
              ...el,
              id: existing ? existing.id : 0,
              document_type_id: el.id,
              document_name: existing ? existing.document_name : "",
              name: el.name,
              path: existing ? existing.path : "",
              sort_order: el.sort_order,
            };
          })
          .sort((a, b) => a.sort_order - b.sort_order);
      } else {
        this.companyForm.documents = filteredFields
          .map((el, index) => {
            return {
              ...el,
              id: 0,
              document_type_id: el.id,
              document_name: "",
              name: el.name,
              path: "",
              sort_order: el.sort_order,
            };
          })
          .sort((a, b) => a.sort_order - b.sort_order);
      }
    },

    async getAddress() {
      if (this.form.province) {
        let id = this.province.find((x) => x.name == this.form.province).id;
        const res = await this.$axios(
          `https://api-hourglass-mobile-dev.dosetech.co/api/v1/Service/Getsubaddress/${id}/${1}`
        );
        this.district = res.detail.district;
        await this.$nextTick();
      }

      if (this.form.district) {
        let id = this.district.find((x) => x.name == this.form.district).id;
        const res = await this.$axios(
          `https://api-hourglass-mobile-dev.dosetech.co/api/v1/Service/Getsubaddress/${id}/${2}`
        );
        this.subdistrict = res.detail.subdistrict;
        await this.$nextTick();
      }
    },
    async save() {
      if (this.form.birthday) {
        const date = new Date(this.form.birthday);

        this.birthday = {
          birthday_day: String(date.getDate()).padStart(2, "0"),
          birthday_month: String(date.getMonth() + 1).padStart(2, "0"),
          birthday_year: date.getFullYear(),
        };
      }

      let dynamic = [];
      for (const fields of this.dynamicField) {
        let target_id = 0;
        if (fields.field_choices.length > 0) {
          const findFieldId = fields.field_choices.find(
            (choice) => choice.name == fields.user_answer
          );
          if (findFieldId) {
            target_id = findFieldId.id;
          }
        }
        dynamic.push({
          id: fields.id,
          value: fields.user_answer,
          target_id: target_id,
        });
      }

      let objTemp = [];

      for (const x of dynamic) {
        var findField = this.dynamicField.find((field) => field.id == x.id);

        if (x.value && typeof x.value == "object") {
          if (x.value.length > 0) {
            for (const a of x.value) {
              const { id } = findField.field_choices.find(
                (choice) => choice.name == a
              );
              objTemp.push({
                id: x.id,
                value: a,
                target_id: id,
              });
            }
          }
        } else {
          objTemp.push(x);
        }
      }
      if (this.form.is_company) {
        this.$v.companyForm.$touch();
      } else {
        this.$v.form.$touch();
      }
      this.consentError = true;
      if (
        this.$v.form.$error ||
        this.$v.companyForm.$error ||
        !this.isConsentError
      ) {
        if (this.$v.companyForm.$error) {
          const fields = this.$v.companyForm;

          for (const key in fields) {
            if (
              !key.startsWith("$") && // ข้าม properties พิเศษของ Vuelidate เช่น $model, $error
              key !== "documents" && // ข้าม documents
              fields[key].$error // ถ้ามี error ใน key นั้น
            ) {
              return;
            }
          }

          // ถ้ามี error แค่ documents
          if (fields.documents.$error) {
            this.tabIndex = 3;
            return;
          }

          return;
        }

        return;
      }
      await this.$store.dispatch("setMainLoading", true);
      this.isLoading = true;
      // this.form.is_id_card = 1;
      let sendForm = this.form.is_company ? this.companyForm : this.form;
      let body = {
        ...sendForm,
        is_company: this.form.is_company,
        is_consent: this.form.is_consent,
        optional_telephone: this.form.optional_telephone || "",
        // ...this.birthday,
        prefix: this.form.is_company
          ? sendForm.otherPrefix || sendForm.prefix
          : this.otherPrefix || this.form.prefix,
        gender: this.otherGender || this.form.gender,
        custom_field: objTemp.filter((el) => el.value),
      };
      body.birthday = this.form.birthday
        ? this.$moment(this.form.birthday).format("YYYY-MM-DD")
        : null;
      body.telephone = body.telephone
        ? `${body.telephone.trim()}${this.ext.tel ? `-${this.ext.tel}` : ""}`
        : "";
      body.email = body.email ? body.email.trim() : "";
      body.user_additional_consent_insert_List = this.consentList.map((el) => {
        return {
          additional_consent_id: el.id,
          sort_order: el.sort_order,
          is_consent: el.is_consent,
        };
      });
      if (this.isEdit) {
        await this.axios
          .post(`${this.$baseUrl}/customer/registerform/EditUserProfile`, body)
          .then((data) => {
            this.$store.dispatch("setMainLoading", false);
            if (data.result == 1) {
              this.successAlert();
              this.$emit("success");
              if (this.companyForm.documents.length && this.form.is_company) {
                this.updateDocument(this.form.user_guid);
              }
              this.isLoading = false;
            } else {
              this.warningAlert(data.message);
            }
          });
      } else {
        await this.axios
          .post(`${this.$baseUrl}/customer/registerform/Register`, body)
          .then((data) => {
            this.$store.dispatch("setMainLoading", false);
            if (data.result == 1) {
              this.successAlert();
              this.$emit("success", data.detail);
              if (this.companyForm.documents.length && this.form.is_company) {
                this.updateDocument(data.detail.user_guid);
              }
              this.isLoading = false;
            } else {
              this.warningAlert(data.message);
            }
          });
      }
    },
    async updateDocument(userGuid) {
      let body = this.companyForm.documents.map((x) => ({
        ...x,
        user_guid: userGuid,
        created_time: this.now,
      }));
      const res = await this.axios.post(
        `${this.$baseUrl}/customer/EditDocument`,
        body
      );
    },
    handleEnter(isPost) {
      if (isPost) {
        this.$refs.postNum.$el.querySelector("input").blur();
      } else {
        this.$refs.lineId.$el.querySelector("input").blur();
      }
    },
    setValue(val, key) {
      this.form[key] = val.target.value;
    },

    checkFieldConditon(obj) {
      return obj.field_conditions[0] ? obj.field_conditions[0].value : "text";
    },
    checkIsProfile(val) {
      if (val == 99) val = 22;
      const findField = fieldInForm2.find((el) => el.id == val);
      return findField ? findField.key : false;
    },
    addTel() {
      this.$emit("AddOptionalTelephone");
    },
    isNumber: function (e) {
      const maxlen = e.target.maxLength;
      const val = e.target.value;

      if (
        (e.key == "e" || e.charCode == 45 || e.charCode == 46) &&
        (e.target.type == "number" || e.target.type == "Number")
      ) {
        return e.preventDefault();
      }
      if (maxlen == -1) {
        return val;
      }

      if (val.length > maxlen - 1) {
        return e.preventDefault();
      }
    },
    handleSelected(val, field, options) {
      if (field == "prefix") {
        let other = options.find((x) => x.choice_type_id == 3);

        let otherName = other ? other.name : "";
        this.form.prefix = val;
        if (val == otherName) {
          this.isOtherPrefix = true;
        } else {
          this.otherPrefix = "";
          this.isOtherPrefix = false;
        }
      } else {
        let other = options.find((x) => x.choice_type_id == 3);
        let otherName = other ? other.name : "";

        this.form.gender = val;
        if (val == otherName) {
          this.isOtherGender = true;
        } else {
          this.otherGender = "";
          this.isOtherGender = false;
        }
      }
    },
    handleChangeCountry(val) {
      this.form.country = val;
      // if (val === "ประเทศไทย") return;
      // else {
      this.form.home_address = null;
      this.form.zip_code = null;
      this.form.province = null;
      this.form.town = null;
      this.form.alley = null;
      this.form.road = null;
      this.form.subdistrict = null;
      this.form.district = null;
      // }
      this.companyForm.country = val;
      // if (val === "ประเทศไทย") return;
      // else {
      this.companyForm.home_address = null;
      this.companyForm.zip_code = null;
      this.companyForm.province = null;
      this.companyForm.town = null;
      this.companyForm.alley = null;
      this.companyForm.road = null;
      this.companyForm.subdistrict = null;
      this.companyForm.district = null;
      // }
    },
    checkRequired(field) {
      if (
        field == "last_name_th" ||
        field == "first_name_th" ||
        field == "telephone"
      )
        return true;
    },
    async handleChangeCompany(val, field) {
      if (field == "province") {
        this.companyForm.province = val;
        let id = this.province.find((x) => x.name == val).id;
        const res = await this.$axios(
          `https://api-hourglass-mobile-dev.dosetech.co/api/v1/Service/Getsubaddress/${id}/${1}`
        );
        this.district = res.detail.district;
        this.companyForm.district = null;
        this.companyForm.subdistrict = null;
        this.companyForm.zip_code = null;
      } else if (field == "district") {
        this.companyForm.district = val;
        let id = this.district.find((x) => x.name == val).id;
        const res = await this.$axios(
          `https://api-hourglass-mobile-dev.dosetech.co/api/v1/Service/Getsubaddress/${id}/${2}`
        );
        this.subdistrict = res.detail.subdistrict;
        this.companyForm.subdistrict = null;
        this.companyForm.zip_code = null;
      } else {
        this.companyForm.subdistrict = val;
        let zip_code = this.subdistrict.find((x) => x.name == val).zip_code;
        this.companyForm.zip_code = zip_code;
      }
    },
    async handleChange(val, field) {
      if (field == "province") {
        this.form.province = val;
        let id = this.province.find((x) => x.name == val).id;
        const res = await this.$axios(
          `https://api-hourglass-mobile-dev.dosetech.co/api/v1/Service/Getsubaddress/${id}/${1}`
        );
        this.district = res.detail.district;
        this.form.district = null;
        this.form.subdistrict = null;
        this.form.zip_code = null;
      } else if (field == "district") {
        this.form.district = val;
        let id = this.district.find((x) => x.name == val).id;
        const res = await this.$axios(
          `https://api-hourglass-mobile-dev.dosetech.co/api/v1/Service/Getsubaddress/${id}/${2}`
        );
        this.subdistrict = res.detail.subdistrict;
        this.form.subdistrict = null;
        this.form.zip_code = null;
      } else {
        this.form.subdistrict = val;
        let zip_code = this.subdistrict.find((x) => x.name == val).zip_code;
        this.form.zip_code = zip_code;
      }
    },
    async loadAddress(val, field) {
      if (field == "province") {
        let id = this.province.find((x) => x.name == val).id;
        const res = await this.$axios(
          `https://api-hourglass-mobile-dev.dosetech.co/api/v1/Service/Getsubaddress/${id}/${1}`
        );
        this.district = res.detail.district;
      } else if (field == "district") {
        let id = this.district.find((x) => x.name == val).id;
        const res = await this.$axios(
          `https://api-hourglass-mobile-dev.dosetech.co/api/v1/Service/Getsubaddress/${id}/${2}`
        );
        this.subdistrict = res.detail.subdistrict;
      } else {
        let zip_code = this.subdistrict.find((x) => x.name == val).zip_code;

        this.form.zip_code = zip_code;
      }
    },
    changeName($fields) {
      return $fields.field_language[0]
        ? $fields.field_language[0].name
        : $fields.name;
    },

    async setImageName(val, id) {
      let res = await this.checkIsProfile(id);
      if (res == "id_card_image")
        this.form.is_company
          ? (this.companyForm.id_card_file_name = val)
          : (this.form.id_card_file_name = val);
    },
    showPolicy() {
      this.$store.dispatch("setPolicyModal", true);
    },
    showTerm() {
      this.$store.dispatch("setTermModal", true);
    },
    async handleChangeTypeRegister(val) {
      const filteredFields = this.documentFields.filter((x) =>
        this.companyForm.company_information === "จดทะเบียน"
          ? x.is_register
          : x.is_not_register
      );
      if (this.isEdit) {
        this.companyForm.documents = filteredFields
          .map((el, index) => {
            const existing = this.companyForm.documents.find(
              (x) => x.document_type_id == el.id
            );

            return {
              ...el,
              id: existing ? existing.id : 0,
              document_type_id: el.id,
              document_name: existing ? existing.document_name : "",
              name: el.name,
              path: existing ? existing.path : "",
              sort_order: el.sort_order,
            };
          })
          .sort((a, b) => a.sort_order - b.sort_order);
      } else {
        this.companyForm.documents = filteredFields
          .map((el, index) => {
            return {
              ...el,
              id: 0,
              document_type_id: el.id,
              document_name: "",
              name: el.name,
              path: "",
              sort_order: el.sort_order,
            };
          })
          .sort((a, b) => a.sort_order - b.sort_order);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.register-box {
  max-height: 500px;
  overflow: auto;
}

::v-deep .custom-select:disabled {
  background-color: #d8dbe0 !important;
}

::v-deep input:disabled {
  background-color: #d8dbe0 !important;
}
.text-link {
  font-size: 14px !important;
  text-decoration: underline;
  cursor: pointer;
  color: var(--primary-color) !important;
}

label {
  color: #333 !important;
  font-size: 14px !important;
  font-weight: bold !important;
  width: 100%;
  position: relative;
}

::v-deep .vdatetime-input {
  border-radius: 5px !important;
  /* padding: 8px 10px; */

  height: 35px !important;
}

.border-red {
  ::v-deep .vdatetime-input {
    border-color: red !important;
  }
}
.calendar-icon {
  position: absolute;
  top: 50%;
  right: 3%;
}
.calendar-icon-top {
  top: 35% !important;
}
.datetime-container {
  position: relative;
}

.title-18px {
  color: #333 !important;
  font-size: 18px !important;
  font-weight: bold !important;
  width: 100%;
  position: relative;
}

.input-type ::v-deep .custom-select {
  width: 150px;
}
</style>
